import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'

import { InputAdornment, TextField } from '@mui/material'
import Search from '@mui/icons-material/Search'

const SearchFieldFilterInput = ({ filter, selectedValues, handleSelectedValues, sx }) => {
  const inputValue = selectedValues[filter.field] ? selectedValues[filter.field] : ''
  const [searchTerm, setSearchTerm] = useState(inputValue)

  useEffect(() => {
    setSearchTerm(inputValue)
  }, [inputValue])

  const handleChange = (e) => {
    setSearchTerm(e.target.value)
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      searchTerm !== '' && handleSelectedValues(null, { [filter.field]: searchTerm })
    }, 1000)

    if (searchTerm === '') {
      handleSelectedValues(null, { [filter.field]: searchTerm })
    }

    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm])

  return (
    <TextField
      label={filter.headerName}
      name={filter.field}
      value={searchTerm}
      type="search"
      variant="outlined"
      onChange={handleChange}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        },
      }}
      sx={sx}
    />
  )
}

SearchFieldFilterInput.propTypes = {
  filter: PropTypes.object,
  FilterWidthClass: PropTypes.object,
  selectedValues: PropTypes.object,
  handleSelectedValues: PropTypes.func,
  sx: PropTypes.object,
}

export default SearchFieldFilterInput
